import ArrowDownGreenIcon from 'assets/ver2/icons/arrow-down-green-icon.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import {
  DESKTOP_MIN_WIDTH,
  RESET_VERIFICATION_UPLOAD_DOCUMENTS,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME,
  VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_FIELD,
  VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_NAME,
} from 'constants';
import {} from 'constants/fx';
import useProfileAPI from 'features/profile2.0/hooks/useProfileAPI';
import useUploadDocumentsAPI from 'features/uploadDocuments/hooks/useUploadDocumentsAPI';
import useForm from 'hooks/form/useForm';
import useAuth from 'hooks/useAuth';
import useCommonStore from 'hooks/useCommonStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  displayFlexRowCenterStartMixin,
  fontSize14Mixin,
  paragraph500Mixin,
} from 'styles';
import FormInputUploadDocumentsFileTakePhotoValidation from './components/FormInputUploadDocumentsFileTakePhotoValidation';
import FormInputUploadDocumentsSelectIdTypeSwitch from './components/FormInputUploadDocumentsSelectIdTypeSwitch';

const initialFormField = RESET_VERIFICATION_UPLOAD_DOCUMENTS;

const VerificationUploadDocumentsDetails = ({
  currentStep,
  setCurrentStep,
  onToggleDrawer,
}) => {
  const { t } = useLang();
  const { isLoading, setLoading } = useCommonStore();
  const { isDesktop } = useDetectDevice();
  const { token } = useAuth();
  const { closePortalModalName } = usePortalModal();

  const {
    information,
    setInformation,
    validation,
    setValidation,
    checkAllowSubmit,
  } = useForm(initialFormField);
  const { getProfileRequest, saveProfileDocsRequest } = useProfileAPI();

  const isDriverLicenceSelected =
    information[
      VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME
    ];

  const isNextButtonDisabled =
    isLoading ||
    !checkAllowSubmit({
      information,
      validation,
      skipProps: [
        VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME,
        ...[
          !isDriverLicenceSelected &&
            VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME,
          !isDriverLicenceSelected &&
            VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME,
        ],
        ...[
          isDriverLicenceSelected &&
            VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME,
        ],
      ],
    });

  const isAutoNextStepDisabled = !checkAllowSubmit({
    information,
    validation,
    skipProps: [
      VERIFICATION_UPLOAD_DOCUMENTS_SELECT_DRIVER_LICENCE_SWITCH_NAME,
      VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_NAME,
      ...[
        !isDriverLicenceSelected &&
          VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME,
        !isDriverLicenceSelected &&
          VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME,
      ],
      ...[
        isDriverLicenceSelected && VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME,
      ],
    ],
  });
  useEffect(() => {
    if (isAutoNextStepDisabled) return;
    setCurrentStep(1);
  }, [isAutoNextStepDisabled]);

  const renderVerificationUploadDocumentsDriverLicence = () => {
    return (
      <>
        <UploadDocumentsForm>
          <FormInputUploadDocumentsFileTakePhotoValidation
            field={VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_FIELD}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
          />
          <FormInputUploadDocumentsFileTakePhotoValidation
            field={VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_FIELD}
            information={information}
            setInformation={setInformation}
            validation={validation}
            setValidation={setValidation}
          />
        </UploadDocumentsForm>
      </>
    );
  };
  const renderVerificationUploadDocumentsPassport = () => {
    return (
      <UploadDocumentsForm>
        <FormInputUploadDocumentsFileTakePhotoValidation
          field={VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_FIELD}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
      </UploadDocumentsForm>
    );
  };
  const renderVerificationUploadDocumentsTypesBodyContent = () => {
    return (
      <>
        <Title
          $isRequired={
            isDriverLicenceSelected
              ? validation[
                  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_FRONT_NAME
                ] ||
                validation[
                  VERIFICATION_UPLOAD_DOCUMENTS_DRIVER_LICENCE_BACK_NAME
                ]
              : validation[VERIFICATION_UPLOAD_DOCUMENTS_PASSPORT_NAME]
          }
        >
          {t('label_upload_documents_select_id_type')}
        </Title>
        <SizeBox height={16} />
        <FormInputUploadDocumentsSelectIdTypeSwitch
          information={information}
          setInformation={setInformation}
        />
        <SizeBox height={16} />
        {isDriverLicenceSelected ? (
          <>{renderVerificationUploadDocumentsDriverLicence()}</>
        ) : (
          <>{renderVerificationUploadDocumentsPassport()}</>
        )}
      </>
    );
  };

  const renderVerificationUploadDocumentsSelfie = () => {
    return (
      <UploadDocumentsForm>
        <FormInputUploadDocumentsFileTakePhotoValidation
          field={VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_FIELD}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
      </UploadDocumentsForm>
    );
  };
  const renderVerificationUploadDocumentsSelfieBodyContent = () => {
    if (currentStep === 0) return null;
    return (
      <>
        <SizeBox height={20} />
        <Title
          $isRequired={validation[VERIFICATION_UPLOAD_DOCUMENTS_SELFIE_NAME]}
        >
          {t('label_upload_documents_select_selfie_type')}
        </Title>
        <SizeBox height={16} />
        {renderVerificationUploadDocumentsSelfie()}
      </>
    );
  };

  const renderVerificationUploadDocumentReminder = () => {
    if (isNextButtonDisabled) return null;
    return (
      <>
        <SizeBox height={20} />
        <ReminderText>
          {t('label_upload_documents_reminder')}{' '}
          <img src={ArrowDownGreenIcon} width={20} height={20} />
        </ReminderText>
      </>
    );
  };

  const { saveProfileDocumentsUploadRequest } = useUploadDocumentsAPI({
    information,
  });
  const handleNextStep = async () => {
    console.log(
      `⭐ VerificationUploadDocumentsDetails 👉 handleNextStep ➡️ information ↩`,
      information
    );
    console.log(
      `⭐ VerificationUploadDocumentsDetails 👉 handleNextStep ➡️ validation ↩`,
      validation
    );
    if (isNextButtonDisabled) return;
    await saveProfileDocumentsUploadRequest({
      isConvertDataURLtoBlob: true,
      isContainDocumentSelfie: true,
      saveProfileDocsRequestOptions: {
        saveProfileDocsRequestSuccessCallback: () => {
          closePortalModalName();
          onToggleDrawer();
        },
      },
    });
  };
  const renderBottomFixed = () => {
    if (isNextButtonDisabled) return null;
    return (
      <>
        <SizeBox height={isDesktop ? 0 : 120} />
        <BottomFixedStyled>
          <ButtonCommon
            value={t('button_save')}
            styles={{
              margin: '0px',
              width: '100%',
              height: '50px',
              ...(isDesktop && {
                width: '100%',
                marginLeft: 'auto',
              }),
            }}
            color={'var(--c-primary)'}
            background={'var(--bg-primary)'}
            onClick={handleNextStep}
            isUseKeyDown
            isFill={true}
          />
        </BottomFixedStyled>
      </>
    );
  };

  return (
    <VerificationUploadDocumentsDetailsStyled>
      {renderVerificationUploadDocumentsTypesBodyContent()}
      {renderVerificationUploadDocumentsSelfieBodyContent()}
      {renderVerificationUploadDocumentReminder()}
      {renderBottomFixed()}
    </VerificationUploadDocumentsDetailsStyled>
  );
};

const VerificationUploadDocumentsDetailsStyled = styled.div`
  height: fit-content;
  width: 100%;
`;

const Title = styled.p`
  ${paragraph500Mixin};
  ${(props) =>
    props.$isRequired &&
    `
    color: var(--ds-c-red);
  `}
`;

const UploadDocumentsForm = styled.div`
  ${displayFlexRowCenterStartMixin};
  gap: 10px;
`;

const ReminderText = styled.p`
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  color: #1aa758;
  ${displayFlexRowCenterStartMixin};
`;

const BottomFixedStyled = styled.div`
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  padding: 12px 16px;
  border-top: 1px solid var(--ds-c-grey-disabled);
  background-color: #fff;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    position: absolute;
  }
`;

export default VerificationUploadDocumentsDetails;
